export interface GeoPosition {
	latitude: number;
	longitude: number;
	accuracy: number;
}

export type GeoErrorCode = 'PERMISSION_DENIED' | 'POSITION_UNAVAILABLE' | 'TIMEOUT' | 'NOT_SUPPORTED';

export class GeoError extends Error {
	code: GeoErrorCode;

	constructor(code: GeoErrorCode, message: string) {
		super(message);
		this.name = 'GeoError';
		this.code = code;
	}
}

const GEO_OPTIONS: PositionOptions = {
	enableHighAccuracy: true,
	timeout: 15000,
	maximumAge: 0,
};

export const getPositionPromise = (): Promise<GeoPosition> =>
	new Promise((resolve, reject) => {
		if (!navigator.geolocation) {
			reject(new GeoError('NOT_SUPPORTED', 'Geolocation is not supported by your browser.'));
			return;
		}

		navigator.geolocation.getCurrentPosition(
			(position) => {
				resolve({
					latitude: position.coords.latitude,
					longitude: position.coords.longitude,
					accuracy: position.coords.accuracy,
				});
			},
			(err) => {
				let code: GeoErrorCode = 'POSITION_UNAVAILABLE';
				let message = 'Unable to determine your location.';

				switch (err.code) {
					case err.PERMISSION_DENIED:
						code = 'PERMISSION_DENIED';
						message = 'Location access was denied. Please enable location permissions in your browser settings.';
						break;
					case err.POSITION_UNAVAILABLE:
						code = 'POSITION_UNAVAILABLE';
						message = "Unable to determine your location. Please check your device's location services.";
						break;
					case err.TIMEOUT:
						code = 'TIMEOUT';
						message = 'Location request timed out. Please try again.';
						break;
				}

				reject(new GeoError(code, message));
			},
			GEO_OPTIONS
		);
	});
